module.exports = __webpack_public_path__ + "static/media/5_years_of_experience.c7d4f6b0.svg";